var React = require('react');

function Plant (props) {
    return React.createElement("svg",props,React.createElement("g",{"clipPath":"url(#a)","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M12 10a6 6 0 0 0-6-6H3v2a6 6 0 0 0 6 6h3M12 14a6 6 0 0 1 6-6h3v1a6 6 0 0 1-6 6h-3M12 20V10"})));
}

Plant.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Plant;

Plant.default = Plant;
